// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Modal shell ──────────────────────────────────────────────────────────── */

.scl--cms-components-editMedia-modal {
  position: relative;
  width: 941px;
  height: 602px;
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12);
  z-index: 200;
}

/* ── Header ───────────────────────────────────────────────────────────────── */

.scl--cms-components-editMedia-header {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 65px;
  flex-shrink: 0;
  background: #F8F9FB;
  border-bottom: 1px solid rgba(229, 229, 231, 0.5);
  display: flex;
  align-items: center;
  padding: 0 24px;
}

.scl--cms-components-editMedia-title {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  color: #323539;
  margin: 0;
  flex: 1;
}

.scl--cms-components-editMedia-closeBtn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-30%);
}

/* ── Body ─────────────────────────────────────────────────────────────────── */

.scl--cms-components-editMedia-body {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: hidden;
}

/* ── Vertical divider ─────────────────────────────────────────────────────── */

.scl--cms-components-editMedia-divider {
  position: absolute;
  left: 458px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: rgba(229, 229, 231, 0.5);
  pointer-events: none;
}

/* ── Left Panel ───────────────────────────────────────────────────────────── */

.scl--cms-components-editMedia-left {
  width: 458px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding: 24px 24px 0 24px;
  gap: 0;
  box-sizing: border-box;
  overflow: hidden;
}

/* Image preview */
.scl--cms-components-editMedia-imageWrapper {
  width: 100%;          /* 24px left panel padding on each side = 410 - but Figma says 398 */
  height: 255px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0px 4px 32px -4px rgba(111, 108, 143, 0.12),
              0px 3px 12px -2px rgba(170, 170, 190, 0.06);
}

.scl--cms-components-editMedia-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Replace Image button */
.scl--cms-components-editMedia-replaceBtn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  width: 100%;
}


/* Hidden file input */
.scl--cms-components-editMedia-fileInput {
  display: none;
}

/* Divider between replace btn and recent list */
.scl--cms-components-editMedia-recentDivider {
  width: 398px;
  height: 1px;
  background: rgba(229, 229, 231, 0.5);
  margin-top: 12px;
  flex-shrink: 0;
}

/* ── Recent section ───────────────────────────────────────────────────────── */

.scl--cms-components-editMedia-recentSection {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 398px;
  margin-top: 12px;
  flex: 1;
  min-height: 0;
}

.scl--cms-components-editMedia-recentLabel {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: #8A8B8F;
  flex-shrink: 0;
  align-self: stretch;
}

/* Scrollable list with custom scrollbar */
.scl--cms-components-editMedia-recentList {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  width: 398px;
  margin-bottom: 14px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 10px;   /* space for scrollbar */
  box-sizing: border-box;

  /* Custom scrollbar — matches Figma spec */
  scrollbar-width: thin;
  scrollbar-color: #7A7A7A #E8E8E8;
}

.scl--cms-components-editMedia-recentList::-webkit-scrollbar {
  width: 4px;
}

.scl--cms-components-editMedia-recentList::-webkit-scrollbar-track {
  background: #E8E8E8;
  border-radius: 100px;
}

.scl--cms-components-editMedia-recentList::-webkit-scrollbar-thumb {
  background: #7A7A7A;
  border-radius: 100px;
}

/* Empty state wrapper */
.scl--cms-components-editMedia-emptyWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  min-height: 0;
}

/* Each recent row is clickable */
.scl--cms-components-editMedia-recentItem {
  cursor: pointer;
  width: 100%;
}

/* ── Right Panel ──────────────────────────────────────────────────────────── */

.scl--cms-components-editMedia-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
  padding: 24px 24px 0 24px;
  box-sizing: border-box;
}

/* ── Fields ───────────────────────────────────────────────────────────────── */

.scl--cms-components-editMedia-fields {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 42px;
  width: 402px;
}

/* Force TextField and TextArea to fill 402px width */
.scl--cms-components-editMedia-fields > * {
  width: 402px !important;
}

/* ── Footer ───────────────────────────────────────────────────────────────── */

.scl--cms-components-editMedia-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 0 24px 23px 24px;
  position: absolute;
  right: 0;
  bottom: 0;
}

.scl--cms-components-editMedia-modal .scl--components-empty-page-icon svg{
     width: 58px;
  height: 46px;
}
.scl--cms-components-editMedia-modal .scl--components-empty-page-title{
  color: var(--typography-text-body-secondary);
  font-weight: 400;
}

.scl--cms-components-editMedia-modal .scl-components-button-RoundSqureButton-md{
    width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/texteditor-fs-cp/edit-media-overlay/css/editMediaOverlay.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,YAAY;AACd;;AAEA,gFAAgF;;AAEhF;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA,gFAAgF;;AAEhF;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,MAAM;EACN,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW,WAAW,oEAAoE;EAC1F,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd;yDACuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;;AAGA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB,IAAI,wBAAwB;EAC/C,sBAAsB;;EAEtB,0CAA0C;EAC1C,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,WAAW;AACb;;AAEA,gFAAgF;;AAEhF;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE,uBAAuB;AACzB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;KACK,WAAW;EACd,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["/* ── Modal shell ──────────────────────────────────────────────────────────── */\n\n.scl--cms-components-editMedia-modal {\n  position: relative;\n  width: 941px;\n  height: 602px;\n  background: #FFFFFF;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12);\n  z-index: 200;\n}\n\n/* ── Header ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-editMedia-header {\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  height: 65px;\n  flex-shrink: 0;\n  background: #F8F9FB;\n  border-bottom: 1px solid rgba(229, 229, 231, 0.5);\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n}\n\n.scl--cms-components-editMedia-title {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 36px;\n  color: #323539;\n  margin: 0;\n  flex: 1;\n}\n\n.scl--cms-components-editMedia-closeBtn {\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-30%);\n}\n\n/* ── Body ─────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-editMedia-body {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n/* ── Vertical divider ─────────────────────────────────────────────────────── */\n\n.scl--cms-components-editMedia-divider {\n  position: absolute;\n  left: 458px;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: rgba(229, 229, 231, 0.5);\n  pointer-events: none;\n}\n\n/* ── Left Panel ───────────────────────────────────────────────────────────── */\n\n.scl--cms-components-editMedia-left {\n  width: 458px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 24px 24px 0 24px;\n  gap: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n/* Image preview */\n.scl--cms-components-editMedia-imageWrapper {\n  width: 100%;          /* 24px left panel padding on each side = 410 - but Figma says 398 */\n  height: 255px;\n  border-radius: 8px;\n  overflow: hidden;\n  flex-shrink: 0;\n  box-shadow: 0px 4px 32px -4px rgba(111, 108, 143, 0.12),\n              0px 3px 12px -2px rgba(170, 170, 190, 0.06);\n}\n\n.scl--cms-components-editMedia-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Replace Image button */\n.scl--cms-components-editMedia-replaceBtn {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  width: 100%;\n}\n\n\n/* Hidden file input */\n.scl--cms-components-editMedia-fileInput {\n  display: none;\n}\n\n/* Divider between replace btn and recent list */\n.scl--cms-components-editMedia-recentDivider {\n  width: 398px;\n  height: 1px;\n  background: rgba(229, 229, 231, 0.5);\n  margin-top: 12px;\n  flex-shrink: 0;\n}\n\n/* ── Recent section ───────────────────────────────────────────────────────── */\n\n.scl--cms-components-editMedia-recentSection {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  width: 398px;\n  margin-top: 12px;\n  flex: 1;\n  min-height: 0;\n}\n\n.scl--cms-components-editMedia-recentLabel {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 22px;\n  color: #8A8B8F;\n  flex-shrink: 0;\n  align-self: stretch;\n}\n\n/* Scrollable list with custom scrollbar */\n.scl--cms-components-editMedia-recentList {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 5px;\n  width: 398px;\n  margin-bottom: 14px;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding-right: 10px;   /* space for scrollbar */\n  box-sizing: border-box;\n\n  /* Custom scrollbar — matches Figma spec */\n  scrollbar-width: thin;\n  scrollbar-color: #7A7A7A #E8E8E8;\n}\n\n.scl--cms-components-editMedia-recentList::-webkit-scrollbar {\n  width: 4px;\n}\n\n.scl--cms-components-editMedia-recentList::-webkit-scrollbar-track {\n  background: #E8E8E8;\n  border-radius: 100px;\n}\n\n.scl--cms-components-editMedia-recentList::-webkit-scrollbar-thumb {\n  background: #7A7A7A;\n  border-radius: 100px;\n}\n\n/* Empty state wrapper */\n.scl--cms-components-editMedia-emptyWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n}\n\n/* Each recent row is clickable */\n.scl--cms-components-editMedia-recentItem {\n  cursor: pointer;\n  width: 100%;\n}\n\n/* ── Right Panel ──────────────────────────────────────────────────────────── */\n\n.scl--cms-components-editMedia-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  position: relative;\n  padding: 24px 24px 0 24px;\n  box-sizing: border-box;\n}\n\n/* ── Fields ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-editMedia-fields {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 42px;\n  width: 402px;\n}\n\n/* Force TextField and TextArea to fill 402px width */\n.scl--cms-components-editMedia-fields > * {\n  width: 402px !important;\n}\n\n/* ── Footer ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-editMedia-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  padding: 0 24px 23px 24px;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n\n.scl--cms-components-editMedia-modal .scl--components-empty-page-icon svg{\n     width: 58px;\n  height: 46px;\n}\n.scl--cms-components-editMedia-modal .scl--components-empty-page-title{\n  color: var(--typography-text-body-secondary);\n  font-weight: 400;\n}\n\n.scl--cms-components-editMedia-modal .scl-components-button-RoundSqureButton-md{\n    width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
